var keyMirror = require('keymirror');

module.exports = keyMirror({
    GET_ORGANISATIONS_RESPONSE: null,
    GET_ACTIVE_ORGANISATIONS_RESPONSE: null,
    GET_ALL_ORGANISATIONS_RESPONSE: null,
    GET_PROFILE_ORGANISATIONS_RESPONSE: null
});